export const GET_NEW_BUSINESSES = "GET_NEW_BUSINESSES";
export const UPDATE_NEW_BUSINESS = "UPDATE_NEW_BUSINESSES";